<template>

    <div>
        <DeliveryAddressRedirect
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.ENTITY"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <EntityTabLinks />
            </template>
        </DeliveryAddressRedirect>
    </div>

</template>

<script>
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import DeliveryAddressRedirect from '@/components/delivery/DeliveryAddressRedirect';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityDeliveryAddressRedirect',

        components: {
            DeliveryAddressRedirect,
            EntityTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/entities/get/${id}`)).data;
        },

        methods: {}
    }
</script>
